<div class="llm-panel">
  <div class="llm-panel__head">
    <div>
      <h3 class="llm-panel__title">{{ 'nextPIM KI-Anbieter' | translate }}</h3>
      <div class="llm-panel__hint">
        {{ 'Zugangsdaten, die nextPIM für alle Kunden ohne eigenen Zugang verwendet' | translate }}
      </div>
    </div>
    <dx-button
      stylingMode="contained"
      type="default"
      icon="plus"
      text="{{ 'Anbieter hinzufügen' | translate }}"
      (onClick)="onAdd()"
    ></dx-button>
  </div>

  <dx-data-grid
    [dataSource]="settings"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    noDataText="{{ 'Keine Anbieter konfiguriert' | translate }}"
    keyExpr="id"
  >
    <dxo-paging [enabled]="false"></dxo-paging>

    <dxi-column dataField="provider" caption="{{ 'Anbieter' | translate }}" [width]="180">
      <dxo-lookup [dataSource]="providers" displayExpr="name" valueExpr="id"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="baseUrl" caption="{{ 'URL' | translate }}" cellTemplate="urlTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'urlTemplate'">
      <span *ngIf="cell.value">{{ cell.value }}</span>
      <span *ngIf="!cell.value" class="llm-muted">{{ 'Standard-URL des Anbieters' | translate }}</span>
    </div>

    <dxi-column dataField="token" caption="{{ 'Token' | translate }}" [width]="150" cellTemplate="tokenTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'tokenTemplate'">
      <span class="llm-token" *ngIf="cell.value">{{ mask(cell.value) }}</span>
      <span class="llm-badge llm-badge--muted" *ngIf="isCustomerOwnedOnly(cell.data)">
        {{ 'nur Kundenzugänge' | translate }}
      </span>
    </div>

    <dxi-column dataField="defaultChatModel" caption="{{ 'Chat-Modell' | translate }}" [width]="220"></dxi-column>
    <dxi-column dataField="defaultEmbeddingModel" caption="{{ 'Embedding-Modell' | translate }}" [width]="200" cellTemplate="embeddingTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'embeddingTemplate'">
      <span *ngIf="cell.value">{{ cell.value }}</span>
      <span *ngIf="!cell.value" class="llm-muted">{{ 'nicht unterstützt' | translate }}</span>
    </div>

    <dxi-column dataField="isDefault" caption="{{ 'Standard' | translate }}" [width]="110" cellTemplate="defaultTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'defaultTemplate'">
      <span class="llm-badge" *ngIf="cell.value">{{ 'Standard' | translate }}</span>
    </div>

    <dxi-column dataField="isEmbeddingProvider" caption="{{ 'Embeddings' | translate }}" [width]="130" cellTemplate="embeddingProviderTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'embeddingProviderTemplate'">
      <span class="llm-badge" *ngIf="cell.value">{{ 'Embeddings' | translate }}</span>
    </div>

    <dxi-column type="buttons" [width]="130">
      <dxi-button hint="{{ 'Bearbeiten' | translate }}" icon="edit" [onClick]="onEdit"></dxi-button>
      <dxi-button hint="{{ 'Verbindung testen' | translate }}" icon="check" [onClick]="onTest" [visible]="isTestable"></dxi-button>
      <dxi-button hint="{{ 'Löschen' | translate }}" icon="trash" [onClick]="onDelete"></dxi-button>
    </dxi-column>
  </dx-data-grid>

  <div class="llm-testresult" *ngIf="testResult">
    <span [class.llm-testresult--ok]="testResult.success" [class.llm-testresult--fail]="!testResult.success">
      {{ testResult.success ? ('Verbindung erfolgreich' | translate) : testResult.error }}
    </span>
    <span class="llm-panel__hint" *ngIf="testResult.success && testResult.models.length">
      {{ testResult.models.length }} {{ 'Modelle verfügbar' | translate }}: {{ testResult.models.join(', ') }}
    </span>
    <span class="llm-panel__hint" *ngIf="testResult.note">{{ testResult.note }}</span>
    <span class="llm-panel__hint" *ngIf="testResult.success && !testResult.note && !testResult.models.length">
      {{ 'Dieser Anbieter stellt keine Modellliste bereit – das konfigurierte Chat-Modell wird verwendet.' | translate }}
    </span>
  </div>
</div>

<dx-popup
  [(visible)]="editorVisible"
  [width]="620"
  [height]="'auto'"
  [showTitle]="true"
  title="{{ 'KI-Anbieter' | translate }}"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'content'">
    <dx-form [(formData)]="editing" labelLocation="top" *ngIf="editing"
             (onFieldDataChanged)="onFieldDataChanged($event)">
      <dxi-item dataField="provider" editorType="dxSelectBox"
                [editorOptions]="{ items: providers, displayExpr: 'name', valueExpr: 'id' }">
        <dxo-label text="{{ 'Anbieter' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="baseUrl">
        <dxo-label text="{{ 'URL' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="token" [editorOptions]="{ mode: 'password' }" [helpText]="tokenHelpText">
        <dxo-label text="{{ 'Token' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="defaultChatModel" [helpText]="modelHelpText">
        <dxo-label [text]="isAzure ? ('Chat-Bereitstellung' | translate) : ('Chat-Modell' | translate)"></dxo-label>
      </dxi-item>
      <dxi-item dataField="defaultEmbeddingModel" [helpText]="modelHelpText">
        <dxo-label [text]="isAzure ? ('Embedding-Bereitstellung' | translate) : ('Embedding-Modell' | translate)"></dxo-label>
      </dxi-item>
      <dxi-item dataField="isDefault" editorType="dxSwitch"
                [editorOptions]="{ disabled: !hasSystemToken }"
                [helpText]="hasSystemToken ? '' : ('Nur mit hinterlegtem nextPIM-Token möglich' | translate)">
        <dxo-label text="{{ 'Als Standard für Textgenerierung verwenden' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item
        dataField="isEmbeddingProvider"
        editorType="dxSwitch"
        [editorOptions]="{ disabled: !supportsEmbeddings || !hasSystemToken }"
        [helpText]="!supportsEmbeddings
          ? ('Dieser Anbieter unterstützt keine Embeddings' | translate)
          : (hasSystemToken
              ? ('Wird für Feldzuordnung und Vektorsuche verwendet' | translate)
              : ('Nur mit hinterlegtem nextPIM-Token möglich' | translate))"
      >
        <dxo-label text="{{ 'Für Embeddings verwenden' | translate }}"></dxo-label>
      </dxi-item>
    </dx-form>

    <div class="llm-editor__error" *ngIf="saveError">{{ saveError }}</div>

    <div class="llm-editor__actions">
      <dx-button stylingMode="text" text="{{ 'Abbrechen' | translate }}" (onClick)="editorVisible = false"></dx-button>
      <dx-button
        stylingMode="contained"
        type="default"
        text="{{ 'Speichern' | translate }}"
        [disabled]="saving"
        (onClick)="onSave()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
